import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { capitalize } from '@as-react/common-utils';
const Label = props => {
    const { translation, htmlFor, required, className } = props;
    const { t } = useTranslation([I18N_NAMESPACES.buy, I18N_NAMESPACES.account, I18N_NAMESPACES.dpe]);
    return (_jsx("label", { className: `${className || 'a-label'} ${required ? ' a-label--required' : ''}`, htmlFor: htmlFor, children: capitalize(t(translation)) }));
};
export { Label };
